import React, { FunctionComponent } from 'react'
import { Heading, Paragraph, majorScale, Link } from 'evergreen-ui'
import DialogLayout from '../DialogLayout'

interface GetAppStepProps {
  onClickNext: () => void
  onClickBack: () => void
}

const GetAppStep: FunctionComponent<GetAppStepProps> = ({ onClickNext, onClickBack }) => (
  <DialogLayout onConfirmClick={onClickNext} confirmLabel="Next" onBackClick={onClickBack}>
    <Heading size={600} marginBottom={majorScale(3)} textAlign="center">
      Get the App
    </Heading>
    <Paragraph paddingX={majorScale(2)} textAlign="center">
      Download and install the{' '}
      <Link href="https://support.google.com/accounts/answer/1066447" target="_blank">
        Google Authenticator
      </Link>
      ,{' '}
      <Link href="https://1password.com/downloads/" target="_blank">
        1Password
      </Link>
      , or{' '}
      <Link href="https://authy.com/download/" target="_blank">
        Authy Authenticator
      </Link>{' '}
      app for your phone or tablet.
    </Paragraph>
  </DialogLayout>
)

export default GetAppStep
